import projectsActions from '@/actions/projectsActions';
import { EXPERIMENT_TAB_PATHNAME } from '@experiment-management-shared/constants/experimentConstants';
import { SELECT_PANEL_PATH } from '@experiment-management-shared/constants/visualizationConstants';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

type UseSetDefaultEMHeaderTabOpts = {
  section: string;
};
const useSetDefaultEMHeaderTab = ({
  section
}: UseSetDefaultEMHeaderTabOpts) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (
      !location.hash.includes(`#${SELECT_PANEL_PATH}`) &&
      !location.hash.includes(`#${EXPERIMENT_TAB_PATHNAME.manage}`)
    ) {
      dispatch(projectsActions.setActiveEMHeaderTab(section));
    }
  }, [dispatch, location.hash, section]);
};

export default useSetDefaultEMHeaderTab;
